
import { defineComponent, PropType, ref } from "vue";
import { microWait } from "@/lib/shared";

export interface IMenuItem {
  name: string;
  icon: string[];
  clickAction: () => Promise<void>;
}

export default defineComponent({
  name: "ThreeDotsMenu",
  props: {
    title: { type: String },
    items: { type: Object as PropType<IMenuItem> },
    isRight: { type: Boolean },
  },
  setup() {
    const menuList = ref<HTMLElement>();
    const isShow = ref(false);
    const show = async () => {
      if (!menuList.value) return;
      isShow.value = true;
      await microWait();
      menuList.value.focus();
    };
    const hide = async (e: FocusEvent) => {
      if (!menuList.value) return;
      const isChildClick = menuList.value.contains(e.relatedTarget as Node);
      if (isChildClick) return;
      isShow.value = false;
    };
    const clickHook = async (f: () => Promise<void>) => {
      await f();
      isShow.value = false;
    };
    return {
      menuList,
      isShow,
      show,
      hide,
      clickHook,
    };
  },
});
